<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

html, body{
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 13pt;
}

a{
  color: rgb(65,103,178);
  text-decoration: none;
}

a:hover{
  text-decoration: underline;
}

.semibold{
  font-weight: 500;
}

</style>



// WEBPACK FOOTER //
// src/App.vue